/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { ReactComponent as PreviewSvg } from 'assets/Icons/find_white.svg';

interface GenerateButtonProps {
  isLoading: boolean;
  onClick: () => void;
}

export const GenerateButton = ({ isLoading, onClick }: GenerateButtonProps) => {
  return (
    <div tw="flex flex-col">
      <div tw="flex items-center gap-1 mb-2 h-5">
        <label tw="text-[10px] font-semibold text-gray-400 tracking-wide whitespace-nowrap leading-none">
        </label>
      </div>
      <button
        className="button large btn-primary"
        onClick={onClick}
        tw="m-0 flex justify-center items-center self-end height[4rem]! shadow ml-0"
        disabled={isLoading}
      >
        <span tw="flex">
          <PreviewSvg tw="mr-3" />
        </span>
        Generate
      </button>
    </div>
  );
};


